const times = (term, count) => {
  let result = [];
  for (let i = 0; i < count; i++) {
    result.push(term);
  }
  return result;
};

export { times };
